/**
 * @desc query
 */
const URL = "/rantion-aider";
import http, { updateResponse } from "@/http";
export function request(params: API.aider.operationLog.query.Params, options?: any) {
  return updateResponse(
    http(URL + `/operation/log/query`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
